import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExportSvg = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4883 9.13911V13.2363C14.4883 13.9267 13.9286 14.4863 13.2383 14.4863H1.98828C1.29792 14.4863 0.738281 13.9267 0.738281 13.2363V1.98633C0.738281 1.29597 1.29793 0.736328 1.98828 0.736328H6.0855",
			stroke: "#B3EC49",
			strokeWidth: 1.47368,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4883 0.736329L5.73828 9.48633",
			stroke: "#B3EC49",
			strokeWidth: 1.47368,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4883 5.73633L14.4883 0.736329L9.48828 0.736328",
			stroke: "#B3EC49",
			strokeWidth: 1.47368,
			strokeLinecap: "round"
		})
	]
});
export default SvgExportSvg;
